export const IconCandidateCvBaseSearch20: {
  name: 'icon_candidate_cv_base_search_20-94ae343baa2f'
} = {
  name: 'icon_candidate_cv_base_search_20-94ae343baa2f'
}
